import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';

import { UserPreferencesEffects } from './user-preferences.effects';

@NgModule({
	imports: [
		EffectsModule.forFeature([UserPreferencesEffects])
	]
})
export class UserPreferencesModule { }
